import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup,UntypedFormBuilder, Validators } from '@angular/forms';
import { AutotextService } from '../autotext.service';
import { ExamsService } from '../exams.service';
import { PatientsService } from '../patients.service';
import { AngularEditorConfig, UploadResponse } from '@kolkov/angular-editor';
import { Observable, Subscription } from 'rxjs';
import { HttpEvent } from '@angular/common/http';

@Component({
    selector: 'app-consultation',
    templateUrl: './consultation.component.html',
    styleUrls: ['./consultation.component.scss'],
    standalone: false
})
export class ConsultationComponent implements OnInit {
  @ViewChild('Title') Title: ElementRef
  consultation: UntypedFormGroup;  
  contentText ='';
  editorConfig: AngularEditorConfig = { editable: true, height: '50vh', toolbarHiddenButtons:[
    ['subscript','superscript','strikeThrough',],[
    'backgroundColor',
    'customClasses',
    'link',
    'unlink',
    'insertImage',
    'insertVideo',
    'removeFormat',
    'toggleEditorMode']
  ]};
  constructor(private patService: PatientsService,public atS: AutotextService, public es: ExamsService, private fb: UntypedFormBuilder) {
   }


  ngOnInit() {    
    this.consultation = this.fb.group({
      FormContent: [''],
      Title: new UntypedFormControl('', Validators.minLength(2))
    });
    this.es.fillForm(this.consultation,"Forms",false,true);
    
  }


}
